module.exports = __webpack_public_path__ + "static/scale-model-of-rodeo-drive-walk-of-style-in-los-angeles-california-1949fdd9118f7ea13cd456480a3e1cf0.png";